import moment from "moment";
import "moment-timezone";

export class DataTransformer {

  static transform(obj) {

    let order = {}

    const data = obj.hasOwnProperty('attributes') ? obj.attributes : obj

    let priorityAbrv = data.priority ? data.priority.replace("HEALTH & SAFETY P1", "P1") : ""; // Fix - Cannot read property 'replace' of null
        priorityAbrv = priorityAbrv.replace("EMERGENCY P2", "P2");
        priorityAbrv = priorityAbrv.replace("EMERGENCY P3", "P3");
        priorityAbrv = priorityAbrv.replace("EMERGENCY P4", "P4");
        priorityAbrv = priorityAbrv.replace("ROUTINE P5", "P5");
        priorityAbrv = priorityAbrv.replace("PROJECTED P6", "P6");

    order.id = obj.id
    order.is_integrated = data.is_integrated  // three states: 0 or 1 or null
    order.assigned_to = data.assigned_to
    order.managed_by = data.managed_by != null ? data.managed_by : ''
    order.firm_id = data.firm_id
    order.contract_id = data.contract_id
    order.created_by_firm_id = data.created_by_firm_id
    order.orderId = data.orderId
    order.claimId = data.claimId
    order.billing_code = data.billing_code
    order.assetCode = data.asset_codes
    order.releaseDate = data.releaseDate;
    order.due_date = data.requiredFinish
    order.orderType = data.orderType
    order.priority = data.priority
    order.address = data.address
    order.status = data.status
    order.startDate = data.startDate
    order.finishDate = data.finishDate
    order.returnToSite = data.return_to_site === 0 ? 'NO' : 'YES'
    order.workDescription = data.workDescription

    order.editable = data.status != 'CLOSED_D' && data.status != 'CLOSED_N' && data.status != 'REJECTED' && data.status != 'INCC_ASSIGNED';


    order.description = priorityAbrv + ' - ' + data.activityType + ' - ' + data.address + ' - ' + data.workDescription


    // NOTE: operations_count isn't always available.
    order.operations_count = data.hasOwnProperty('operations_count')
      ? data.operations_count
      : undefined
    order.work_instruction =
      data.orderType + ' / ' + data.priority + ' / ' + data.address
    order.loggedLat = data.logged_lat
    order.loggedLng = data.logged_lng
    order.activityType = data.activityType
    order.plannerGroup = data.plannerGroup
    order.latitudeStart = data.latitude_start
    order.longitudeStart = data.longitude_start
    order.latitudeFinish = data.latitude_finish
    order.longitudeFinish = data.longitude_finish
    order.loggedXCoordinate = data.loggedXCoordinate
    order.loggedYCoordinate = data.loggedYCoordinate
    order.requiredStart = data.requiredStart
    order.requiredFinish = data.requiredFinish
    order.actualStart = data.actual_start
    order.actualFinish = data.actual_finish
    order.madeSafe = data.made_safe
    order.kpiStart = data.kpi_start
    order.kpiFinish = data.kpi_finish
    order.parentOrder = data.parentOrder
    order.requestedStart = data.requested_start
    order.requestedFinish = data.requested_finish
    order.claimLinesTotal = data.claimLinesTotal

    order.locked_at = data.locked_at;
    order.assigned_to = data.assigned_to;
    // order.aux_data = data.aux_data;
    order.duplicateOf = data.duplicateOf;
    order.contractor_job_number = data.contractor_job_number;
    order.dateChangeRequestStart = data.date_change_request_start;
    order.dateChangeRequestFinish = data.date_change_request_finish;
    order.started_via_app = data.started_via_app;
    order.stopped_via_app = data.stopped_via_app;
    order.model_type = data.model_type;
    order.coding = data.coding;

    order.order_type_id = data.order_type_id;
    order.order_subtype_id = data.order_subtype_id;
    order.problem_code_id = data.problem_code_id;

    order.scheduled_log_id = data.scheduled_log_id;

    order.supplierOrderId = data.supplierOrderId;

    order.location_asset_id = data.location_asset_id;

    return order
  }
}



// WEBPACK FOOTER //
// ./src/helpers/orders/data.transformer.js